import * as LocationQueries from '../../queries/location';
import { makeApolloClient, logError } from '../util';

export const SET_EVENT_LOCATIONS = 'SET_EVENT_LOCATIONS';
export const CREATE_LOCATION = 'CREATE_LOCATION';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const DELETE_LOCATION = 'DELETE_LOCATION';

const fetchEventLocations = (locations, from) => ({
	type: SET_EVENT_LOCATIONS,
	from,
	locations,
});

export const createLocation = (location, from) => ({
	type: CREATE_LOCATION,
	location,
	from,
});

export const updateLocation = (location, from) => ({
	type: UPDATE_LOCATION,
	location,
	from,
});

export const deleteLocation = (locationID, from) => ({
	type: DELETE_LOCATION,
	locationID,
	from,
});

export const thunkFetchEventLocations = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventLocations } = await client.request(LocationQueries.EVENT_LOCATIONS, {
			event_id: eventID,
		});
		dispatch(fetchEventLocations(eventLocations, from));
	} catch (error) {
		logError(error, 'locations.actions.thunkFetchEventLocations');
	}
};
